import { useEffect, useState } from "react";
import SpecialtyDropdown from "../../shared/SpecialtyDropdown";
import Npi from "../../shared/NPI/NPI";
import { useNavigate } from "react-router-dom";
import CallAPI from "../../../services/apiCalls";
import useUserStore from "../../../utils/storeApp";
import { stateCodeArray } from "../../../services/fakeDB/ListUser";
import $ from "jquery";
import { MdnDispatchMode, KeepMdnMode } from "../../../utils/enums";

let o = {
  AdminCount: 0,
  Abbreviation: "",
  CredentialText: "",
  DomainBox: "",
  DomainId: 0,
  DomainName: null,
  ExternalId: "",
  IDs: [],
  Id: null,
  IsCertAddress: true,
  IsEpicOrganization: false,
  KeepMDN: KeepMdnMode.No,
  NPI: "",
  OrgEmailCount: 0,
  OrganizationKind: null,
  OrganizationName: "",
  OrganizationType: "",
  OrgClassificationCode: "CE",
  OutOfNetwork: false,
  ParentOrg: "",
  ParentOrganizationId: null,
  ParentOrganizationName: null,
  Specialties: [],
  Addresse: {
    FirstLine: "",
    SecondLine: "",
    City: "",
    State: "",
    County: "",
    PostalCode: "",
    Country: "",
    Phone: "",
    PhoneExt: "",
    Fax: "",
    FaxExt: "",
    AddressType: 0,
  },
  SubOrgCount: 0,
  UserCount: 0,
  UserEmailCount: 0,
  VendorId: 0,
  VendorVal: "",
  XDRDoNOTGenerateXDM: false,
  XDREnabled: false,
  xdrConfig: {
    Id: null,
    IsValid: false,
    OrganizationId: null,
    UseConfigFile: false,
    EndpointName: "",
    EndpointAddress: "",
    ClientCertificate: false,
    ClientCertificateFindValue: "",
    SchemaValidatorOn: false,
    SchemaValidateRequest: false,
    SchemaValidateResponse: false,
    MDNForward: false,
  },
  AllowTwoFactor: false,
  ApplicationAccessXDR: false,
  ApplicationAccessENS: false,
  specializationCode: "",
  TwoFactorauth: false,
  EmailForwardingType: 0,
  DirectRoute: false,
  AdvancedDirectRoute: false,
  ShareDirectoryListing: false,
  GatewayModeEnabled: false,
  MdnDispatchMode: MdnDispatchMode.Conditional,
};

const RegistrationOrgForm = () => {
  const navigate = useNavigate();
  const {
    userToken,
    userRole,
    customerObj,
    XdrArr,
    setXDRArr,
    sharedObject,
    SetSharedObject,
    userSession,
    backendTarget,
  } = useUserStore((state) => ({
    userToken: state.userToken,
    isUserLogedIn: state.isUserLogedIn,
    userRole: state.userRole,
    customerObj: state.customerObj,
    XdrArr: state.XdrArr,
    setXDRArr: state.setXDRArr,
    sharedObject: state.sharedObject,
    SetSharedObject: state.SetSharedObject,
    userSession: state.userSession,
    backendTarget: state.backendTarget,
  }));
  const showOnDemandOption = !!userSession?.is_gcp_user || backendTarget === "gcp";
  const [processing, SetProcessing] = useState(false);
  const [errMsg, SetErrMsg] = useState(false);
  const [answers, setAnswers] = useState(o);
  const [orgValues, SetOrgValues] = useState([]);
  const [custObject, SetCustObject] = useState([]);
  const [orgObject, SetOrgObject] = useState([]);
  const [customerPermissionsObj, SetCustomerPermissionsObj] = useState({});
  const [orgPermissionsObj, SetOrgPermissionsObj] = useState({});
  const [ParentXDRObj, SetParentXDRObj] = useState(false);
  const [noPermissions, SetNoPermissions] = useState(true);
  const [specialtiesFlag, SetspecialtiesFlag] = useState(false);
  const [userEditDetails, setUserEditDetails] = useState(false);

  const setAnswer = async (questionId, answer, chck) => {
    if (chck) {
      let obj = { ...answers };
      let add = answers.Addresse;
      add[questionId] = answer;
      obj.Addresse = add;
      await setAnswers(obj);
    } else {
      await setAnswers({ ...answers, [questionId]: answer });
    }
  };
  const getUser = async (id) => {
    let TrustedAgent = false;
    SetProcessing(true);
    let call = "/users/getUserById?userId=" + id;
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let det = res.data.data;
      setUserEditDetails(det.userContact);
      TrustedAgent = det.userContact.trustedAgent;
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetProcessing(false);
      TrustedAgent = false;
    }
    return TrustedAgent;
  };
  const getUserAsync = async () => {
    if (
      userRole !== "SES ADMINISTRATOR" &&
      userRole !== "SYSTEMADMINISTRATOR"
    ) {
      let tAFlag = await getUser(userSession.sesuser_id);
      return tAFlag;
    }
  };
  useEffect(() => {
    const resetAsync = async () => {
      await ResetData();
    };
    if (sharedObject.AddOrgFlag === true) {
      resetAsync();
      SetSharedObject("AddOrgFlag", false);
    }
    const buildXDR = async (ob) => {
      await setAnswers((prev) => ({
        ...prev,
        xdrConfig: ob.xdrConfig,
        OutboundXDRConfigName: ob.OutboundXDRConfigName,
        ParentOrg: ob.ParentOrg ?? prev.ParentOrg,
      }));
    };
    if (ParentXDRObj) buildXDR(ParentXDRObj);
  }, [ParentXDRObj]);

  useEffect(() => {
    const resetAsync = async () => {
      await ResetData();
    };
    if (sharedObject.AddOrgFlag === true) {
      resetAsync();
      SetSharedObject("AddOrgFlag", false);
    }
    const getOrgVals = async (val) => {
      let tAFlag = await getUserAsync();
      let cust = null;
      if (val.Type === "top") {
        let temp = [];
        for (let el of sharedObject.vendorsObj) {
          el.show = true;
          temp.push(el);
          if (el.id === parseInt(val.VendorId)) {
            let vl = el.baseDomainId + "-" + el.id;
            getVendorsDomains(vl, el.name);
          }
        }
        SetCustObject(temp);
      } else {
        if (
          userRole !== "SES ADMINISTRATOR" &&
          userRole !== "SYSTEMADMINISTRATOR"
        ) {
          let vl = userSession.vendor_id;
          let custTemp = {};
          for (let el of sharedObject.vendorsObj) {
            if (parseInt(vl) === el.id) {
              custTemp = el;
            }
          }
          cust = custTemp;
          SetCustomerPermissionsObj(custTemp);
        } else {
          cust = sharedObject.CustomerPermissionsObj;
        }
      }
      if (
        cust.emailForwardingType === 0 &&
        cust.twoFactorAuth === false &&
        cust.applicationAccessXDR === false &&
        cust.applicationAccessENS === false &&
        cust.directorySharing === false &&
        cust.gatewayModeEnabled === false
      ) {
        await SetNoPermissions(true);
      } else {
        await SetNoPermissions(false);
      }

      let chck = false;
      let tempOrg = [];
      let tempSelOrg = {};
      for (let el of sharedObject.getOrgsObj) {
        if (
          userRole !== "SES ADMINISTRATOR" &&
          userRole !== "SYSTEMADMINISTRATOR"
        ) {
          el.vendorId = userSession.vendor_id;
        }
        if (
          sharedObject.orgActionObj &&
          sharedObject.orgActionObj.id === el.id
        ) {
          tempSelOrg = el;
        }
        el.show = true;
        tempOrg.push(el);
      }
      SetOrgPermissionsObj(tempSelOrg);
      SetOrgObject(tempOrg);
      getXDREndPoints();
      if (sharedObject.orgActionObj) {
        let org = sharedObject.orgActionObj;
        let vId =
          userRole !== "SES ADMINISTRATOR" && userRole !== "SYSTEMADMINISTRATOR"
            ? userSession.vendor_id
            : org.VendorId;
        var o = "";
        if (org.name) {
          o = `${org.name}~${org.id}~${vId}`;
        } else {
          o = `${org.organizationName}~${org.id}~${vId}`;
        }
        await setAnswers({ ...answers, ParentOrg: o });
        if (val.Type === "sub" || tAFlag) {
          GetDomainsByOrg(o, val.domainName, tAFlag);
        }
      }
    };
    let obj = sharedObject.orgActionObj;
    if (obj && Object.keys(obj).length > 0 && obj.constructor === Object) {
      getOrgVals(obj);
    } else {
      getUserAsync();
      let tempOrg = [];
      for (let el of sharedObject.getOrgsObj) {
        if (
          userRole !== "SES ADMINISTRATOR" &&
          userRole !== "SYSTEMADMINISTRATOR"
        ) {
          el.vendorId = userSession.vendor_id;
        }
        el.show = true;
        tempOrg.push(el);
      }
      SetOrgObject(tempOrg);
      let temp = [];
      let tempCustObj = [];
      for (let el of sharedObject.vendorsObj) {
        if (
          userRole !== "SES ADMINISTRATOR" &&
          userRole !== "SYSTEMADMINISTRATOR" &&
          el.id === parseInt(userSession.vendor_id)
        ) {
          tempCustObj = el;
        }
        el.show = true;
        temp.push(el);
      }
      SetCustObject(temp);
      SetCustomerPermissionsObj(tempCustObj);
    }
    SetSharedObject("selectedXdrSettiingObj", {});
    if (
      userRole !== "SES ADMINISTRATOR" &&
      userRole !== "SYSTEMADMINISTRATOR" &&
      userRole !== "ADMINISTRATOR"
    ) {
      setAnswer(
        "VendorVal",
        userSession.domain_id + "-" + userSession.vendor_id,
        false,
      );
    }

    SetspecialtiesFlag(false);
    if (sharedObject?.xdrAdded) {
      GetXdrConfig(sharedObject.xdrAdded);
    }
    return () => {
      ResetData();
      SetCustomerPermissionsObj({});
      SetspecialtiesFlag(false);
      SetSharedObject("xdrAdded", false);
      SetSharedObject("orgActionObj", {});
    };
  }, []);

  // Keep the Customer dropdown in sync with the active backend's customer list.
  // when the SES admin toggles AWS<->GCP, loadUserValues() reloads sharedObject.vendorsObj — rebuild the dropdown from it
  // so it reflects the selected backend without a manual page refresh.
  // Guarded to top-level org registration (customerObj.OrgType === "top") — the only case
  // where this Customer dropdown is rendered — so sub-org / non-admin flows that use
  // custObject differently are unaffected.
  useEffect(() => {
    if (customerObj?.OrgType === "top" && Array.isArray(sharedObject.vendorsObj)) {
      SetCustObject(sharedObject.vendorsObj.map((el) => ({ ...el, show: true })));
    }
  }, [sharedObject.vendorsObj, customerObj]);

  const ResetData = async () => {
    let AddresseObj = {
      FirstLine: "",
      SecondLine: "",
      City: "",
      State: "",
      County: "",
      PostalCode: "",
      Country: "",
      Phone: "",
      PhoneExt: "",
      Fax: "",
      FaxExt: "",
      AddressType: 0,
    };
    await setAnswers({ ...o, Addresse: AddresseObj });
  };
  const getXDREndPoints = async () => {
    SetProcessing(true);
    let call = "/organization/getAllXDREndPoints";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      await setXDRArr(res.data.data);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
    SetProcessing(false);
  };
  const CheckSpecialty = () => {
    let flag =
      isEmpty(sharedObject.specialties.Code) &&
      (!isEmpty(sharedObject.specialties.Type) ||
        !isEmpty(sharedObject.specialties.Classification));
    return flag;
  };
  function isEmpty(value) {
    let x =
      value == null || (typeof value === "string" && value.trim().length === 0);
    return x;
  }
  const [frmSubmFlag, SetFrmSubmFlag] = useState(false);
  const [errCreateMsg, SetErrCreateMsg] = useState(false);
  const [msg, SetMsg] = useState("");
  const [colorMsg, SetColorMsg] = useState("danger");
  const SubmitOrgRegistration = async () => {
    SetFrmSubmFlag(true);
    SetErrMsg(false);
    SetErrCreateMsg(false);
    SetspecialtiesFlag(false);
    if (!answers.OrganizationName) {
      document.getElementById("OrganizationName").scrollIntoView();
      document.getElementById("OrganizationName").focus();
      return;
    } else if (!answers.ParentOrg && customerObj.Type === "sub") {
      document.getElementById("ParentOrg").scrollIntoView();
      document.getElementById("ParentOrg").focus();
      return;
    } else if (!answers.VendorVal && customerObj.Type === "top") {
      document.getElementById("VendorVal").scrollIntoView();
      document.getElementById("VendorVal").focus();
      return;
    } else if (
      !answers.DomainBox &&
      (userRole === "SES ADMINISTRATOR" || userRole === "SYSTEMADMINISTRATOR")
    ) {
      document.getElementById("DomainBox").scrollIntoView();
      document.getElementById("DomainBox").focus();
      return;
    } else if (
      answers.OrganizationKind === null ||
      answers.OrganizationKind === undefined
    ) {
      document.getElementById("OrganizationKind").scrollIntoView();
      document.getElementById("OrganizationKind").focus();
      return;
    } else if (!answers.Addresse.FirstLine) {
      document.getElementById("FirstLine").scrollIntoView();
      document.getElementById("FirstLine").focus();
      return;
    } else if (!answers.Addresse.City) {
      document.getElementById("City").scrollIntoView();
      document.getElementById("City").focus();
      return;
    } else if (!answers.Addresse.State) {
      document.getElementById("State").scrollIntoView();
      document.getElementById("State").focus();
      return;
    } else if (!answers.Addresse.PostalCode) {
      document.getElementById("PostalCode").scrollIntoView();
      document.getElementById("PostalCode").focus();
      return;
    } else if (!answers.Addresse.Phone) {
      document.getElementById("Phone").scrollIntoView();
      document.getElementById("Phone").focus();
      return;
    } else if (!isEmpty(sharedObject.specialties) && CheckSpecialty()) {
      SetspecialtiesFlag(true);
      return;
    }
    if (
      answers.Addresse?.Phone.replace(/[^0-9]/g, "").substring(0, 10).length <
        10 ||
      answers.Addresse?.Phone.replace(/[^0-9]/g, "").substring(0, 10).length >
        10
    ) {
      document.getElementById("Phone").scrollIntoView();
      document.getElementById("Phone").focus();
      return;
    }
    if (
      answers.Addresse?.Fax !== null &&
      answers?.Addresse?.Fax.length > 0 &&
      (answers?.Addresse?.Fax.replace(/[^0-9]/g, "").substring(0, 10).length <
        10 ||
        answers.Addresse?.Fax.replace(/[^0-9]/g, "").substring(0, 10).length >
          10)
    ) {
      document.getElementById("Fax").scrollIntoView();
      document.getElementById("Fax").focus();
      return;
    }
    if (answers.XDREnabled) {
      if (answers.xdrConfig === null) {
        SetMsg("Please select an XDR Endpoint");
        SetErrMsg(true);
        return;
      }
      if (answers.xdrConfig.Id === null) {
        SetMsg("Please select an XDR Endpoint");
        SetErrMsg(true);
        return;
      }
    }

    let pExt = answers.Addresse.PhoneExt ? answers.Addresse.PhoneExt : "";
    let fExt = answers.Addresse.FaxExt ? answers.Addresse.FaxExt : "";
    answers.Addresse.Phone =
      answers.Addresse.Phone.replace(/[^0-9]/g, "").substring(0, 10) + pExt;
    answers.Addresse.Fax =
      answers.Addresse.Fax.replace(/[^0-9]/g, "").substring(0, 10) + fExt;
    answers.Addresse.IsCertAddress = true;
    answers.Addresses = [answers.Addresse];
    let vl = answers.DomainBox.split("~");
    answers.DomainId =
      userRole === "SES ADMINISTRATOR" ||
      userRole === "SYSTEMADMINISTRATOR" ||
      userEditDetails?.trustedAgent
        ? vl[0]
        : userSession.domain_id;
    answers.DomainName =
      userRole === "SES ADMINISTRATOR" ||
      userRole === "SYSTEMADMINISTRATOR" ||
      userEditDetails?.trustedAgent
        ? vl[1]
        : userSession.domain_name;
    if (customerObj.Type === "sub") {
      let vId = answers.ParentOrg.split("~");
      answers.VendorId = parseInt(vId[2]);
    } else {
      let custVal = answers.VendorVal.split("-");
      answers.VendorId = parseInt(custVal[1]);
    }

    let specCode = null;
    if (answers.specializationCode && answers.specializationCode != "") {
      specCode = answers.specializationCode;
    } else {
      specCode = "Empty";
      answers.Specialties = [];
    }
    if (!isEmpty(answers.NPI)) {
      let obj = {
        RecordId: 0,
        IDType: 0,
        Value: answers.NPI,
        IssuingAuthority: "CMS",
      };
      answers.IDs = [obj];
    }
    SetProcessing(true);
    let call =
      "/organization/CreateUpdateOrganization?specializationCode=" + specCode;

    const payload = { ...answers, KeepMDN: showOnDemandOption ? answers.KeepMDN : answers.KeepMDN !== 0 };
    const res = await CallAPI(call, payload, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetColorMsg("success");
      let callOrgs = "/organization/GetOrgs";
      const resOrg = await CallAPI(callOrgs, false, "get", userToken);
      await SetSharedObject("ResponseCode", resOrg.code);
      if (resOrg.status === "SUCCESS") {
        let orgObj = resOrg.data.data;
        SetSharedObject("getOrgsObj", orgObj);
        let oObj = {
          ...answers,
          id: parseInt(res.data.org),
          Name: answers.OrganizationName,
          vendorId: answers.VendorId,
        };
        SetSharedObject("orgActionObjForUser", oObj);
      }
      SetMsg("Organization has been added successfully.");
      SetErrCreateMsg(true);
      SetProcessing(false);

      navigate("/org-registration-success");
    } else if (
      res.status === "SERVERERROR" ||
      res.status === "REGISTRATIONERROR"
    ) {
      let msg = res.data;
      if (Object.keys(msg).length > 0 && msg.constructor === Object) {
        let str = "<div>";
        for (let el in msg) {
          str += `${el}`;
        }
        str += "</div>";
        SetMsg(str);
      } else {
        SetMsg(msg);
      }
      SetErrCreateMsg(true);
      SetColorMsg("danger");
      SetProcessing(false);
    }
  };
  const userEdit = (obj) => {
    setAnswers({
      ...answers,
      OrganizationName: obj.Name,
      Addresse: obj.Addresses,
      NPI: obj.NPI,
    });
  };
  const SpecialFormFields = async (val) => {
    await setAnswers({
      ...answers,
      Specialties: [val],
      specializationCode: val.Code,
    });
  };

  const filterList = (val, list, setter, key = "name") => {
    const search = val.toLowerCase();
    const showAll = val.length <= 1;
    const updated = list?.map((item) => ({
      ...item,
      show: showAll || item[key].toLowerCase().includes(search),
    }));

    setter(updated);
  };
  const filterDomains = (val) =>
    filterList(val, vendorObject, SetVendorObject, "text");
  const filterVendors = (val) =>
    filterList(val, custObject, SetCustObject, "name");
  const filterOrganizations = (val) =>
    filterList(val, orgObject, SetOrgObject, "name");

  const [vendorObject, SetVendorObject] = useState([]);
  const getVendorsDomains = async (val, flag) => {
    setAnswer("VendorVal", val);
    if (val === "") return;
    let domId = val.split("-");
    let vl = "";
    let tmp = {};
    let permissionFlag = false;
    sharedObject?.vendorsObj?.map((el) => {
      if (el.id === parseInt(domId[1])) {
        tmp = el;
        if (
          el.emailForwardingType === 0 &&
          el.twoFactorAuth === false &&
          el.applicationAccessXDR === false &&
          el.applicationAccessENS === false &&
          el.directorySharing === false &&
          el.gatewayModeEnabled === false
        ) {
          permissionFlag = true;
        }
      }
    });
    SetNoPermissions(permissionFlag);
    SetCustomerPermissionsObj(tmp);
    SetProcessing(true);
    let call = "/organization/GetVendorDomains?BaseDomanID=" + domId[0];
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let ob = res.data.data;
      const temp = [];
      for (let el of ob) {
        el.show = true;
        if (flag && parseInt(domId[0]) === parseInt(el.value)) {
          vl = el.value + "~" + el.text;
        }
        temp.push(el);
      }
      await setAnswers({
        ...answers,
        DomainBox: vl,
        VendorVal: val,
      });
      SetVendorObject(temp);
    }
    SetProcessing(false);
  };
  const GetXdrConfig = async (vl, flag) => {
    let temp = {};
    for (let el of XdrArr) {
      if (el.id === parseInt(vl)) {
        temp = el;
        break;
      }
    }

    SetSharedObject("xdrSettiingObj", temp);
    let ob = {
      xdrConfig: temp,
      OutboundXDRConfigName: parseInt(vl),
    };
    if (flag) {
      ob = {
        ...ob,
        XDREnabled: true,
        ApplicationAccessXDR: customerPermissionsObj.applicationAccessXDR,
        ParentOrg: flag,
      };
    }
    SetParentXDRObj(ob);
  };
  const handleXDR = () => {
    GetXdrConfig(answers.OutboundXDRConfigName);
    $("#xdrSettingModal").modal("show");
  };

  const GetDomainsByOrg = async (val, name, tfaFlag) => {
    setAnswer("OrganizationKind", "");
    SetCustomerPermissionsObj({});
    if (val === "") return;
    let org = val.split("~");
    let tmp = {};
    let permissionFlag = false;
    sharedObject?.vendorsObj?.map((el) => {
      if (el.id === parseInt(org[2])) {
        tmp = el;
        if (
          el.emailForwardingType === 0 &&
          el.twoFactorAuth === false &&
          el.applicationAccessXDR === false &&
          el.applicationAccessENS === false &&
          el.directorySharing === false &&
          el.gatewayModeEnabled === false
        ) {
          permissionFlag = true;
        }
      }
    });
    let tempSelOrg = {};
    for (let el of sharedObject.getOrgsObj) {
      if (parseInt(org[1]) === el.id) {
        tempSelOrg = el;
      }
    }

    SetOrgPermissionsObj(tempSelOrg);
    SetNoPermissions(permissionFlag);
    SetCustomerPermissionsObj(tmp);
    let xdrOb = {
      Id: null,
      IsValid: false,
      OrganizationId: null,
      UseConfigFile: false,
      EndpointName: "",
      EndpointAddress: "",
      ClientCertificate: false,
      ClientCertificateFindValue: "",
      SchemaValidatorOn: false,
      SchemaValidateRequest: false,
      SchemaValidateResponse: false,
      MDNForward: false,
    };

    SetProcessing(true);
    let vl = "";
    let configId = "";
    let callXDR = "/organization/getXDRConfigByOrgId?orgId=" + org[1];
    const resXDR = await CallAPI(callXDR, false, "get", userToken);
    await SetSharedObject("ResponseCode", resXDR.code);
    if (resXDR.status === "SUCCESS") {
      let id = resXDR?.data?.data?.id;
      if (typeof id !== "undefined" && id !== null) {
        GetXdrConfig(id, val);
        configId = id;
        let xdrObj = resXDR?.data?.data;
        xdrOb = {
          Id: xdrObj.id,
          IsValid: xdrObj.isValid,
          OrganizationId: xdrObj.organizationId,
          UseConfigFile: xdrObj.useConfigFile,
          EndpointName: xdrObj.endpointName,
          EndpointAddress: xdrObj.endpointAddress,
          ClientCertificate: xdrObj.clientCertificate,
          ClientCertificateFindValue: xdrObj.clientCertificateFindValue,
          SchemaValidatorOn: xdrObj.schemaValidatorOn,
          SchemaValidateRequest: xdrObj.schemaValidateRequest,
          SchemaValidateResponse: xdrObj.schemaValidateResponse,
          MDNForward: xdrObj.mdnForward,
        };
      }
      SetSharedObject("xdrSettiingObj", {});
    } else if (resXDR.status === "SERVERERROR") {
      SetProcessing(false);
    }
    if (
      userRole === "SES ADMINISTRATOR" ||
      userRole === "SYSTEMADMINISTRATOR" ||
      userEditDetails?.trustedAgent ||
      tfaFlag
    ) {
      let call = "/organization/getVendorDomainsByOrg?orgId=" + org[1];
      const res = await CallAPI(call, false, "get", userToken);
      await SetSharedObject("ResponseCode", res.code);
      if (res.status === "SUCCESS") {
        SetVendorObject(res.data.data);
        let ob = res.data.data;
        const temp = [];

        for (let el of ob) {
          el.show = true;
          if (name === el.text) {
            vl = el.value + "~" + el.text;
          }
          temp.push(el);
        }
        SetVendorObject(temp);
      } else if (res.status === "SERVERERROR") {
        SetProcessing(false);
      }
    }

    buildPerm(tempSelOrg, parseInt(org[1]), org[0], val, vl, configId, xdrOb);
    SetProcessing(false);
  };
  const buildPerm = async (
    tempSelOrg,
    orgId,
    orgName,
    val,
    vl,
    configId,
    xdrOb,
  ) => {
    const orgObjTemplate = {
      XDRDoNOTGenerateXDM: tempSelOrg.xdrDoNOTGenerateXDM,
      XDREndpointConfigurationId: tempSelOrg.xdrEndpointConfigurationId,
      KeepMDN: typeof tempSelOrg.keepMDN === "boolean"
        ? (tempSelOrg.keepMDN ? KeepMdnMode.Yes : KeepMdnMode.No)
        : (tempSelOrg.keepMDN ?? KeepMdnMode.No),
      ApplicationAccessXDR: tempSelOrg.applicationAccessXDR,
      ApplicationAccessENS: tempSelOrg.applicationAccessENS,
      TwoFactorAuth: tempSelOrg.twoFactorAuth,
      ShareDirectoryListing: tempSelOrg.shareDirectoryListing,
      GatewayModeEnabled: tempSelOrg.gatewayModeEnabled,
      MdnDispatchMode: tempSelOrg.mdnDispatchMode,
      IsEpicOrganization: tempSelOrg.epicOrganization,
      XDREnabled:
        tempSelOrg.applicationAccessXDR && tempSelOrg.xdrEndpointConfigurationId
          ? true
          : false,
      OutboundXDRConfigName: configId,
    };
    await setAnswers({
      ...answers,
      ...orgObjTemplate,
      ParentOrg: val,
      ParentOrganizationId: orgId,
      ParentOrganizationName: orgName,
      DomainBox: vl,
      xdrConfig: xdrOb,
    });
  };

  const [DirectRoute, SetDirectRoute] = useState(false);
  const [AdvancedDirectRoute, SetAdvancedDirectRoute] = useState(false);
  const setForwardingType = (type, value) => {
    if (type === "DirectRoute") {
      SetDirectRoute(value);
      if (value === true) {
        setAnswer("EmailForwardingType", 1);
      } else {
        setAnswer("EmailForwardingType", 0);
      }
    } else if (type === "AdvancedDirectRoute") {
      SetAdvancedDirectRoute(value);
      if (value === true) {
        setAnswer("EmailForwardingType", 2);
      } else {
        setAnswer("EmailForwardingType", 0);
      }
    }
  };
  function formatPhoneNumber(value) {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6,
    )}-${phoneNumber.slice(6, 10)}`;
  }

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  return (
    <div className="RegistrationOrgForm" id="RegistrationOrgForm">
        <form className="form-container">
          {/*NPI*/}
          {/*<label htmlFor="">Organization</label>*/}

          {customerObj.OrgType === "top" ? (
            <div className="field-wrapper">
              <label htmlFor="VendorVal">Customer</label>
              <span className="filter-container dg-clr">
                <input
                  className="form-control filter-sm"
                  type="search"
                  placeholder="Filter"
                  aria-label="Filter Customers"
                  onChange={(el) => filterVendors(el.target.value)}
                />
              </span>
              <select
                className="form-control"
                size="5"
                id="VendorVal"
                name="VendorVal"
                value={answers.VendorVal}
                aria-label="Customer"
                onChange={(el) => {
                  let obj = el.target.value;
                  SetCustomerPermissionsObj(obj);
                  getVendorsDomains(el.target.value);
                }}
              >
                <option
                  value=""
                  onClick={() => {
                    SetNoPermissions(true);
                  }}
                >
                  Select Customer
                </option>
                {custObject.map((el) => {
                  if (el.show)
                    return (
                      <option key={el.id} value={el.baseDomainId + "-" + el.id}>
                        {el.name}
                      </option>
                    );
                })}
              </select>
              {!answers.VendorVal && frmSubmFlag ? (
                <div className="alert alert-danger">Customer is required.</div>
              ) : null}
            </div>
          ) : null}
          {/*Parent Org*/}
          {customerObj.Type === "sub" ? (
            <div className="field-wrapper">
              <label htmlFor="ParentOrg">Parent Organization</label>
              <span className="filter-container dg-clr">
                <input
                  className="form-control filter-sm"
                  type="search"
                  placeholder="Filter"
                  aria-label="Filter Organizations"
                  onChange={(el) => filterOrganizations(el.target.value)}
                />
              </span>
              <select
                size="5"
                className="form-control"
                name="ParentOrg"
                id="ParentOrg"
                value={answers.ParentOrg}
                aria-invalid={answers.ParentOrg === "" && frmSubmFlag}
                aria-describedby={
                  !answers.ParentOrg && frmSubmFlag ? "ParentOrgError" : undefined
                }
                onChange={(el) => {
                  setAnswer("ParentOrg", el.target.value);
                  GetDomainsByOrg(el.target.value);
                }}
              >
                <option value="">Select Organization</option>
                {orgObject?.map((el) => {
                  if (el.show)
                    return (
                      <option
                        key={el.id}
                        value={el.name + "~" + el.id + "~" + el.vendorId}
                      >
                        {el.name}
                      </option>
                    );
                })}
              </select>
              {!answers.ParentOrg && frmSubmFlag ? (
                <div className="alert alert-danger" role="alert" id="ParentOrgError" aria-live="assertive">
                  Parent Organization is required.
                </div>
              ) : null}
            </div>
          ) : null}
          <Npi userEdit={userEdit} />
          {/*Org Name*/}
          <div className="field-wrapper">
            <label htmlFor="OrganizationName">Organization Name</label>
            <input
              className="form-control"
              name="OrganizationName"
              id="OrganizationName"
              autoComplete="organization"
              aria-invalid={!answers.OrganizationName && frmSubmFlag}
              aria-describedby={
                 !answers.OrganizationName && frmSubmFlag ? "OrganizationNameError" : undefined
            }
              value={answers.OrganizationName}
              onChange={(el) => setAnswer("OrganizationName", el.target.value)}
            />
            {!answers.OrganizationName && frmSubmFlag ? (
              <div className="alert alert-danger" role="alert" id="OrganizationNameError">
                Organization Name is required.
              </div>
            ) : null}
          </div>
          {/*Abbreviation + Domain Name — sub-org + GCP users only*/}
          {customerObj.Type === "sub" && showOnDemandOption ? (
            <>
              <div className="field-wrapper">
                <label htmlFor="Abbreviation">Abbreviation</label>
                <input
                  className="form-control"
                  name="Abbreviation"
                  id="Abbreviation"
                  autoComplete="off"
                  placeholder="Optional"
                  value={answers.Abbreviation}
                  maxLength={25}
                  onChange={(el) => {
                    const validChars = el.target.value
                      .replace(/[^a-zA-Z0-9-]/g, "")
                      .toLowerCase();
                    setAnswer("Abbreviation", validChars);
                  }}
                />
              </div>
              <div className="field-wrapper">
                <label htmlFor="DomainNameDerived">Domain Name</label>
                <input
                  className="form-control"
                  id="DomainNameDerived"
                  name="DomainNameDerived"
                  readOnly
                  value={(() => {
                    const domainText = answers.DomainBox
                      ? answers.DomainBox.split("~")[1]
                      : userRole !== "SES ADMINISTRATOR" && userRole !== "SYSTEMADMINISTRATOR"
                        ? userSession.domain_name
                        : "";
                    if (!domainText) return "";
                    return answers.Abbreviation
                      ? `${answers.Abbreviation}.${domainText}`
                      : domainText;
                  })()}
                />
              </div>
            </>
          ) : null}
          {/*Org Type*/}
          <div className="field-wrapper field-box7 v-top">
            <label htmlFor="OrganizationKind">Organization Type</label>
            <select
              className="form-control"
              name="OrganizationKind"
              id="OrganizationKind"
              value={answers.OrganizationKind}
              aria-invalid={answers.OrganizationKind === "" && frmSubmFlag}
              aria-describedby={
                !answers.OrganizationKind && frmSubmFlag ? "OrganizationKindError" : undefined
              }
              onChange={(el) => {
                let val = el.target.value;
                setAnswer("OrganizationKind", parseInt(val));
              }}
            >
              <option value="">Select</option>
              {sharedObject?.getOrgKinds?.map((el) => (
                <option key={el.id} value={el.id}>
                  {el.description}
                </option>
              ))}
            </select>
            {(answers.OrganizationKind === null ||
              answers.OrganizationKind === undefined) &&
            frmSubmFlag ? (
              <div className="alert alert-danger" role="alert" id="OrganizationKindError" aria-live="assertive">
                Organization Type is required.
              </div>
            ) : null}
          </div>
           {/*Org Classification*/}
          <div className="field-wrapper  field-box8 v-top">
            <label htmlFor="OrgClassificationCode">Organization Classification</label>
            <select
              className="form-control"
              name="OrgClassificationCode"
              id="OrgClassificationCode"
              value={answers.OrgClassificationCode ?? "CE"}
              onChange={(el) => setAnswer("OrgClassificationCode", el.target.value)}
            >
              {sharedObject?.orgClassifications?.map((el) => (
                <option key={el.code} value={el.code}>
                  {el.name}
                </option>
              ))}
            </select>
          </div>
          {userRole === "SES ADMINISTRATOR" ||
          userRole === "SYSTEMADMINISTRATOR" ||
          userEditDetails?.trustedAgent ? (
            <div className="field-wrapper">
              <label htmlFor="DomainBox">Domain</label>
              <span className="filter-container dg-clr spacer-margin8">
                <input
                  className="form-control filter-sm"
                  type="search"
                  placeholder="Filter"
                  aria-label="Filter Domains"
                  onChange={(el) => filterDomains(el.target.value)}
                />
              </span>
              <select
                className="form-control"
                name="DomainBox"
                id="DomainBox"
                size="5"
                value={answers.DomainBox}
                aria-invalid={!answers.DomainBox && frmSubmFlag}
                aria-describedby={!answers.DomainBox && frmSubmFlag ? "DomainBoxError" : undefined}
                onChange={(el) => {
                  let val = el.target.value;
                  setAnswer("DomainBox", val);
                }}
              >
                <option value={false}>Select</option>
                {vendorObject
                  .filter((el) => el.show)
                  .map((el) => (
                    <option key={el.value} value={el.value + "~" + el.text}>
                      {el.text}
                    </option>
                  ))}
              </select>
              {!answers.DomainBox && frmSubmFlag ? (
                <div className="alert alert-danger" role="alert" id="DomainBoxError" aria-live="assertive">
                  Domain is required.
                </div>
              ) : null}
            </div>
          ) : null}

          {/*Contact Information*/}
          <h6 className="field-wrapper title-divider sp-pad9" id="contactInformationTitle">Contact Information</h6>
          {/*Address 1*/}
          <div className="field-wrapper field-box2">
            <label htmlFor="FirstLine">Address 1</label>
            <input
              className="form-control"
              name="FirstLine"
              id="FirstLine"
              autoComplete="address-line1"
              value={answers?.Addresse?.FirstLine}
              onChange={(el) => setAnswer("FirstLine", el.target.value, true)}
              aria-invalid={!answers.Addresse.FirstLine && frmSubmFlag}
              aria-describedby={!answers.Addresse.FirstLine && frmSubmFlag ? "FirstLineError" : undefined}
            />
            {!answers.Addresse.FirstLine && frmSubmFlag ? (
              <div className="alert alert-danger" role="alert" id="FirstLineError" aria-live="assertive">
                Address is required.
              </div>
            ) : null}
          </div>
          {/*Address 2*/}
          <div className="field-wrapper field-box3">
            <label htmlFor="SecondLine">Address 2</label>
            <input
              className="form-control"
              id="SecondLine"
              name="SecondLine"
              autoComplete="address-line2"
              placeholder="Optional"
              value={answers.Addresse.SecondLine}
              onChange={(el) => setAnswer("SecondLine", el.target.value, true)}
            />
          </div>
          <div className="field-wrapper field-box2">
            <label htmlFor="City">City</label>
            <input
              className="form-control"
              name="City"
              id="City"
              autoComplete="address-level2"
              value={answers.Addresse.City}
              onChange={(el) => setAnswer("City", el.target.value, true)}
              aria-invalid={!answers.Addresse.City && frmSubmFlag}
              aria-describedby={!answers.Addresse.City && frmSubmFlag ? "CityError" : undefined}
            />
            {!answers.Addresse.City && frmSubmFlag ? (
              <div className="field-wrapper">
                <div className="alert alert-danger" role="alert" id="CityError" aria-live="assertive">City is required.</div>
              </div>
            ) : null}
          </div>
          <div className="field-wrapper field-box3">
            <div className="spacer-margin5 spacer-inline field-ext">
              <label htmlFor="org-registration-state">State</label>
              <select
                className="form-control"
                name="State"
                id="org-registration-state"
                value={answers.Addresse.State}
                onChange={(el) => setAnswer("State", el.target.value, true)}
                aria-invalid={!answers.Addresse.State && frmSubmFlag}
                aria-describedby={!answers.Addresse.State && frmSubmFlag ? "StateError" : undefined}
              >
                <option value="">Select</option>
                {stateCodeArray.map((el) => (
                  <option key={el} value={el}>
                    {el}
                  </option>
                ))}
              </select>
            </div>
            {/*Zip Code*/}
            <div className="spacer-inline field-ext sp-mx1">
              <label htmlFor="PostalCode">Zip</label>
              <input
                className="form-control"
                id="PostalCode"
                name="PostalCode"
                autoComplete="postal-code"
                aria-invalid={!answers.Addresse.PostalCode && frmSubmFlag}
                aria-describedby={!answers.Addresse.PostalCode && frmSubmFlag ? "PostalCodeError" : undefined}
                value={answers.Addresse.PostalCode}
                maxLength={5}
                onChange={(el) => {
                  const onlyNums = el.target.value.replace(/[^0-9]/g, "");
                  setAnswer("PostalCode", onlyNums, true);
                }}
              />
            </div>
            {!answers.Addresse.State && frmSubmFlag ? (
              <div className="field-wrapper">
                <div className="alert alert-danger" role="alert" id="StateError" aria-live="assertive">State is required.</div>
              </div>
            ) : null}
            {!answers.Addresse.PostalCode && frmSubmFlag ? (
              <div className="field-wrapper">
                <div className="alert alert-danger" role="alert" id="PostalCodeError" aria-live="assertive">Zip is required.</div>
              </div>
            ) : null}
            {answers?.Addresse.PostalCode &&
            answers?.Addresse.PostalCode?.length < 5 &&
            frmSubmFlag ? (
              <div className="field-wrapper">
                <div className="alert alert-danger" role="alert" id="PostalCodeError" aria-live="assertive">Invalid Zip Code</div>
              </div>
            ) : null}
          </div>
          {/*Phone*/}
          <div className="field-wrapper ">
            <div className="field-box2">
              <label htmlFor="Phone">Phone</label>
              <input
                className="form-control"
                id="Phone"
                name="Phone"
                autoComplete="tel"
                aria-invalid={!answers.Addresse.Phone && frmSubmFlag}
                aria-describedby={!answers.Addresse.Phone && frmSubmFlag ? "PhoneError" : undefined}
                value={formatPhoneNumber(answers.Addresse.Phone)}
                onChange={(el) => {
                  setAnswer("Phone", el.target.value, true);
                }}
              />
              {!answers.Addresse.Phone && frmSubmFlag ? (
                <div className="alert alert-danger" role="alert" id="PhoneError" aria-live="assertive">
                  Phone number is required.
                </div>
              ) : null}
              {answers.Addresse?.Phone &&
              answers.Addresse?.Phone.replace(/[^0-9]/g, "").substring(0, 10)
                .length < 10 &&
              frmSubmFlag ? (
                <div className="alert alert-danger" role="alert" id="PhoneError" aria-live="assertive">Invalid Phone Number</div>
              ) : null}
            </div>
            <div className="spacer-inline field-ext v-top">
              <label htmlFor="PhoneExt">Ext</label>
              <input
                className="form-control"
                id="PhoneExt"
                name="PhoneExt"
                autoComplete="tel-extension"
                maxLength={6}
                value={answers.Addresse.PhoneExt}
                onChange={(el) => {
                  const onlyNums = el.target.value.replace(/[^0-9]/g, "");
                  setAnswer("PhoneExt", onlyNums, true);
                }}
              />
            </div>
          </div>
          {/*Fax*/}
          <div className="field-wrapper">
            <div className="field-box2">
              <label htmlFor="Fax">Fax</label>
              <input
                className="form-control"
                id="Fax"
                name="Fax"
                autoComplete="off"
                placeholder="Optional"
                aria-invalid={!answers.Addresse.Fax && frmSubmFlag}
                aria-describedby={!answers.Addresse.Fax && frmSubmFlag ? "FaxError" : undefined}
                value={formatPhoneNumber(answers.Addresse.Fax)}
                onChange={(el) => {
                  setAnswer("Fax", el.target.value, true);
                }}
              />
              {answers.Addresse?.Fax &&
              answers.Addresse?.Fax.replace(/[^0-9]/g, "").substring(0, 10)
                .length < 10 &&
              frmSubmFlag ? (
                <div className="alert alert-danger" role="alert" id="FaxError" aria-live="assertive" aria-atomic="true">Invalid Fax Number</div>
              ) : null}
            </div>
            <div className="spacer-inline field-ext v-top">
              <label htmlFor="FaxExt">Ext</label>
              <input
                className="form-control"
                id="FaxExt"
                name="FaxExt"
                autoComplete="off"
                maxLength={6}
                disabled={
                  answers.Addresse.Fax.replace(/[^0-9]/g, "").length === 0
                }
                value={answers.Addresse.FaxExt}
                onChange={(el) => {
                  const onlyNums = el.target.value.replace(/[^0-9]/g, "");
                  setAnswer("FaxExt", onlyNums, true);
                }}
              />
            </div>
          </div>
          {/*External ID*/}
          <div className="field-wrapper">
            <label htmlFor="ExternalId">External ID</label>
            <input
              className="form-control"
              name="ExternalId"
              id="ExternalId"
              autoComplete="off"
              value={answers.ExternalId}
              onChange={(el) => setAnswer("ExternalId", el.target.value)}
              placeholder="Optional"
            />
          </div>
         
          {/*Specialty*/}
          <h6 className="field-wrapper title-divider sp-pad9" id="specialtyTitle">Specialty</h6>
          <div className="field-wrapper descript-container">
            This section is optional but we highly recommend you select these
            options to identify specific areas of focus in the organization.{" "}
            <strong className="or-clr">
              If you select a type, then you must select both classification and
              specialization.
            </strong>
          </div>
          {/*Specialty Component*/}
          <SpecialtyDropdown
            SpecialFormFields={(el, val) => SpecialFormFields(el, val)}
            codes={orgValues?.codes}
          />
          {specialtiesFlag && frmSubmFlag ? (
            <div className="alert alert-danger" role="alert" id="SpecialtyId" aria-live="assertive" aria-atomic="true">
              Specialization is required when you are selecting Type or
              Classification.
            </div>
          ) : null}

          <h6 className="field-wrapper title-divider sp-pad9" id="emailDeliveryTitle">Email Delivery</h6>
          {/*Email Delivery*/}
          <div className="field-wrapper spacer-inline spacer-margin1 sp-mx">
            <label htmlFor="KeepMDN" className="spacer-inline spacer-margin5">
              Keep MDN:
            </label>
            <select
              className="form-control  w-md3 spacer-inline"
              name="KeepMDN"
              id="KeepMDN"
              value={answers.KeepMDN}
              onChange={(el) =>
                setAnswer("KeepMDN", parseInt(el.target.value))
              }
            >
              <option value="1">Yes</option>
              <option value="0">No</option>
              {showOnDemandOption && <option value="2">On Demand</option>}
            </select>
          </div>
          <div className="field-wrapper spacer-inline sp-mx">
            <label htmlFor="SendMDN" className="spacer-inline spacer-margin5">
              Send Dispatched MDN:
            </label>
            <select
              className="form-control w-md3 spacer-inline"
              name="SendMDN"
              id="SendMDN"
              value={answers.MdnDispatchMode}
              onChange={(el) =>
                setAnswer("MdnDispatchMode", parseInt(el.target.value))
              }
            >
              <option value="1">Yes</option>
              <option value="0">No</option>
              {showOnDemandOption && <option value="2">On Demand</option>}
            </select>
          </div>
          {userRole !== "SES ADMINISTRATOR" &&
          userRole !== "SYSTEMADMINISTRATOR" ? null : (
            <>
              <section>
                <h6 className="field-wrapper title-divider sp-pad9" id="permissionsTitle">Permissions</h6>
                <div className="field-wrapper">
                  {/*Two-Factor Enable or Disable*/}
                  {noPermissions === true ? (
                    <div className="sub-catg ctr" aria-live="polite" role="status" aria-atomic="true">
                      There are no permissions for this organization.
                    </div>
                  ) : null}
                  {customerPermissionsObj.twoFactorAuth === true ? (
                    <div>
                      <div 
                        id="permissionsDescription"
                        className="descript-container"
                        >
                        Select the checkbox for the options you want to include
                        for this organization. You can update these settings at
                        any time from the Organization page.
                      </div>
                      <fieldset aria-labelledby="permissionsDescription">
                        <input
                          className="form-control spacer-margin5"
                          type="checkbox"
                          name="TwoFactorAuth"
                          id="TwoFactorAuth"
                          checked={answers.TwoFactorAuth}
                          value={answers.TwoFactorAuth}
                          onChange={(el) =>
                            setAnswer("TwoFactorAuth", el.target.checked)
                          }
                          aria-describedby={
                            !answers.TwoFactorAuth && frmSubmFlag ? "TwoFactorAuthError" : undefined
                          }
                        />
                        <label htmlFor="TwoFactorAuth">Two Factor Authentication</label>
                        <span>
                          <a
                            href="#twoFactorInfo"
                            data-toggle="collapse"
                            aria-expanded="false"
                            aria-controls="TwoFactorInfo"
                            aria-describedby="twoFactorInfo"
                            aria-label="More info on Two Factor Authentication"
                          >
                            <i className="bi bi-info-circle" aria-hidden="true"></i>
                          </a>
                        </span>
                      </fieldset>
                      <section className="collapse text-reg" id="twoFactorInfo">
                        Two-factor authentication improves your digital security
                        by protecting your account with an additional login
                        step. It makes it harder for unauthorized users to gain
                        access to an account without permission.
                      </section>
                    </div>
                  ) : null}

                  {/*Notify Enable or Disable*/}
                  {customerPermissionsObj.applicationAccessENS === true ? (
                    <div>
                      <section>
                        <input
                          className="form-control spacer-margin5"
                          type="checkbox"
                          name="ApplicationAccessENS"
                          id="ApplicationAccessENS"
                          checked={answers.ApplicationAccessENS}
                          value={answers.ApplicationAccessENS}
                          onChange={(el) =>
                            setAnswer("ApplicationAccessENS", el.target.checked)
                          }
                          aria-describedby={
                            !answers.ApplicationAccessENS && frmSubmFlag ? "ApplicationAccessENSError" : undefined
                          }
                        />
                        <label htmlFor="ApplicationAccessENS">Notify</label>
                      </section>
                    </div>
                  ) : null}
                  {/*DirectRoute Enable or Disable*/}
                  {customerPermissionsObj.emailForwardingType &&
                  customerPermissionsObj.emailForwardingType === 1 ? (
                    <div>
                      <section>
                        <input
                          className="form-control spacer-margin5"
                          type="checkbox"
                          name="DirectRoute"
                          id="DirectRoute"
                          checked={DirectRoute}
                          value={DirectRoute}
                          onChange={(el) =>
                            setForwardingType("DirectRoute", el.target.checked)
                          }
                          disabled={AdvancedDirectRoute}
                          aria-describedby={
                            !DirectRoute && frmSubmFlag ? "DirectRouteError" : undefined
                          }
                        />
                        <label htmlFor="DirectRoute">DirectRoute</label>
                      </section>
                    </div>
                  ) : null}
                  {customerPermissionsObj.emailForwardingType &&
                  customerPermissionsObj.emailForwardingType === 2 ? (
                    <div>
                      <section>
                        <input
                          className="form-control spacer-margin5"
                          type="checkbox"
                          name="AdvancedDirectRoute"
                          id="AdvancedDirectRoute"
                          checked={AdvancedDirectRoute}
                          value={AdvancedDirectRoute}
                          onChange={(el) =>
                            setForwardingType(
                              "AdvancedDirectRoute",
                              el.target.checked,
                            )
                          }
                          aria-describedby={
                            !AdvancedDirectRoute && frmSubmFlag ? "AdvancedDirectRouteError" : undefined
                          }
                          disabled={DirectRoute}
                        />
                        <label htmlFor="AdvancedDirectRoute">Advanced DirectRoute</label>
                      </section>
                    </div>
                  ) : null}
                  {customerPermissionsObj.gatewayModeEnabled === true ? (
                    <div>
                      <section>
                        <input
                          className="form-control spacer-margin5"
                          type="checkbox"
                          name="GatewayModeEnabled"
                          id="GatewayModeEnabled"
                          checked={answers.GatewayModeEnabled}
                          value={answers.GatewayModeEnabled}
                          onChange={(el) =>
                            setAnswer("GatewayModeEnabled", el.target.checked)
                          }
                          aria-describedby={
                            !answers.GatewayModeEnabled && frmSubmFlag ? "GatewayModeEnabledError" : undefined
                          }
                        />
                        <label htmlFor="GatewayModeEnabled">Gateway Mode</label>
                      </section>
                    </div>
                  ) : null}
                  {/*Share Directory Listing Enable or Disable*/}
                  {customerPermissionsObj.directorySharing === true ? (
                    <div>
                      <section>
                        <input
                          className="form-control spacer-margin5"
                          type="checkbox"
                          name="ShareDirectoryListing"
                          id="ShareDirectoryListing"
                          checked={answers.ShareDirectoryListing}
                          value={answers.ShareDirectoryListing}
                          onChange={(el) =>
                            setAnswer(
                              "ShareDirectoryListing",
                              el.target.checked,
                            )
                          }
                          aria-describedby={
                            !answers.ShareDirectoryListing && frmSubmFlag ? "ShareDirectoryListingError" : undefined
                          }
                        />
                        <label htmlFor="ShareDirectoryListing">Share Directory Listing</label>
                      </section>
                    </div>
                  ) : null}
                  {/*XDR Access Enable or Disable*/}
                  {customerPermissionsObj.applicationAccessXDR === true ? (
                    <div>
                      <section>
                        <input
                          className="form-control spacer-margin5"
                          type="checkbox"
                          name="ApplicationAccessXDR"
                          id="ApplicationAccessXDR"
                          checked={answers?.ApplicationAccessXDR}
                          value={answers?.ApplicationAccessXDR}
                          onChange={(el) =>
                            setAnswer("ApplicationAccessXDR", el.target.checked)
                          }
                          aria-describedby={
                            !answers?.ApplicationAccessXDR && frmSubmFlag ? "ApplicationAccessXDRError" : undefined
                          }
                        />
                        <label htmlFor="ApplicationAccessXDR">XDR-Access</label>
                      </section>
                    </div>
                  ) : null}
                </div>
              </section>

              {customerPermissionsObj.applicationAccessXDR === true &&
              answers?.ApplicationAccessXDR ? (
                <>
                    <div className="field-wrapper">
                      <label htmlFor="XDREnabled">Inbound XDR:</label>
                      <input
                        className="form-control spacer-margin2"
                        name="XDREnabled"
                        id="XDREnabled"
                        type="checkbox"
                        checked={answers.XDREnabled}
                        onChange={(el) =>
                          setAnswer("XDREnabled", el.target.checked)
                        }
                        aria-describedby={ !answers.XDREnabled && frmSubmFlag ? "XDREnabledError" : undefined}
                      />
                      <select
                        className="form-control w-lg1 spacer-inline"
                        name="OutboundXDRConfigName"
                        id="OutboundXDRConfigName"
                        value={answers.OutboundXDRConfigName}
                        onChange={(el) => {
                          SetSharedObject("xdrAdded", false);
                          GetXdrConfig(el.target.value);
                        }}
                        disabled={!answers.XDREnabled}
                        aria-describedby={
                          !answers.OutboundXDRConfigName && frmSubmFlag ? "OutboundXDRConfigNameError" : undefined
                        }
                      >
                        <option value="">
                          Add Or Select XDR Configuration
                        </option>
                        {XdrArr?.map((el) => (
                          <option key={el.id} value={el.id}>
                            {el.endpointName}
                          </option>
                        ))}
                      </select>
                      <button
                        type="button"
                        className="btn btn-primary spacer-margin2"
                        onClick={(el) => handleXDR()}
                        data-toggle="modal"
                        disabled={!answers.XDREnabled}
                        aria-describedby={
                          !answers.XDREnabled && frmSubmFlag ? "XDREnabledError" : undefined
                        }
                      >
                        <i className="bi bi-gear" aria-hidden="true"></i>
                      </button>
                    </div>
                </>
              ) : null}
              {customerPermissionsObj.applicationAccessXDR === true &&
              answers?.ApplicationAccessXDR ? (
                <div className="field-wrapper">
                  <span className="custom-label">Outbound XDR</span>
                  <div>
                    <section>
                      <input
                        className="form-control spacer-margin5"
                        type="checkbox"
                        name="IsEpicOrganization"
                        id="IsEpicOrganization"
                        checked={answers.IsEpicOrganization}
                        value={answers.IsEpicOrganization}
                        onChange={(el) =>
                          setAnswer("IsEpicOrganization", el.target.checked)
                        }
                        aria-invalid={!answers.IsEpicOrganization && frmSubmFlag}
                        aria-describedby={
                          !answers.IsEpicOrganization && frmSubmFlag ? "IsEpicOrganizationError" : undefined
                        }
                      />
                      <span htmlFor="IsEpicOrganization" className="label-sub">
                        Create Direct Addresses Automatically
                      </span>
                      <a
                        href="#CreateDirect"
                        data-toggle="collapse"
                        aria-expanded="false"
                        aria-controls="CreateDirect"
                      >
                        <i className="bi bi-plus-lg sm-icon-container" aria-hidden="true"></i>
                      </a>
                      <div
                        className="collapse text-reg sub-catg"
                        id="CreateDirect"
                      >
                        Emails are created in the organization according to the
                        certificate used to authenticate the INBOUND connection.
                      </div>
                    </section>
                  </div>
                  <section>
                    <input
                      className="form-control spacer-margin5"
                      type="checkbox"
                      name="XdrDoNOTGenerateXDM"
                      id="XdrDoNOTGenerateXDM"
                      aria-invalid={!answers.XDRDoNOTGenerateXDM && frmSubmFlag}
                      aria-describedby={
                        !answers.XDRDoNOTGenerateXDM && frmSubmFlag ? "XdrDoNOTGenerateXDMError" : undefined
                      }
                      checked={!answers.XDRDoNOTGenerateXDM}
                     // value={!answers.XDRDoNOTGenerateXDM}
                      onChange={(el) =>
                        setAnswer(
                          "XDRDoNOTGenerateXDM",
                          !answers.XDRDoNOTGenerateXDM,
                        )
                      }
                    />
                    <span htmlFor="XdrDoNOTGenerateXDM" className="label-sub">
                      XDM Delivery
                    </span>
                    <a
                      href="#xdmDelivery"
                      data-toggle="collapse"
                      aria-expanded="false"
                      aria-controls="xdmDelivery"
                      aria-label="More information on XDM Delivery"
                    >
                      <i className="bi bi-plus-lg sm-icon-container" aria-hidden="true"></i>
                    </a>
                    <div
                      className="collapse text-reg sub-catg"
                      id="xdmDelivery"
                    >
                      If checked, message delivered over XDR will be packaged as
                      Direct message with XDM attachment. Please make sure your
                      recipients can accept and handle XDM.
                    </div>
                  </section>
                </div>
              ) : null}

              {errCreateMsg ? (
                <div className={`alert alert-${colorMsg}`} role="alert" aria-live="assertive">{msg}</div>
              ) : null}
            </>
          )}
          {/* Registration Action*/}
          <div className="button-register-container">
            <button
              onClick={(el) => SubmitOrgRegistration()}
              type="button"
              className="btn btn-success"
            >
              Register
            </button>
            <button
              className="btn btn-outline-secondary spacer-margin2"
              type="button"
              onClick={(el) => {
                ResetData();
                SetSharedObject("orgActionObj", false);
                navigate("/Organizations");
              }}
            >
              Cancel
            </button>
                {processing && (
                    <div 
                        className="loader-container" 
                        role="status" 
                        aria-live="polite" 
                        aria-atomic="true"
                        aria-labelledby="loader-id"
                    >
                        <div className="spinner" aria-hidden="true"></div>
                        <div className="loading-text" id="loader-id">{loadingText}</div>
                    </div>
                )}
          </div>
        </form>
    </div>
  );
};

export default RegistrationOrgForm;
